import { useParams } from "@/components/hooks/use-params";
import { CAMPAIGN_ID_PARAM } from "@/constants";

export const useCampaignId = (): string | undefined => {
  const params = useParams<Record<string, string>>();
  return params[CAMPAIGN_ID_PARAM] || undefined;
};
